<script setup lang="ts">
import { ComputedRef, inject } from 'vue';

import { TSDataTable } from 'tsv2-library';
import { FetchResponse } from 'tsv2-library/dist/src/components/v2/DataTable/DataTable.vue';

import {
  childColumns,
  confirmColumns,
} from '@/components/common/options/columns';
import useTableStore from '@/store/table.store';
import { BorrowingTransactionRequest } from '@/types/borrowing.type';
import { BorrowingRequestFetchParams } from '@/types/params.type';

defineProps<{
  search?: string;
  fetchFunction: (
    params: BorrowingRequestFetchParams,
  ) => Promise<FetchResponse | undefined>;
  isConfirmed: boolean;
}>();

const isLinkedAsset = inject('isLinkedAsset') as ComputedRef<boolean>;

const { tableKey } = useTableStore();

const selectedData = defineModel<BorrowingTransactionRequest[]>(
  'selectedData',
  {
    required: true,
  },
);

const columns = confirmColumns();
const childrenColumns = childColumns(false, false);
</script>
<template>
  <TSDataTable
    :key="tableKey"
    v-if="!isConfirmed"
    v-model:selected-data="selectedData"
    :children-columns="isLinkedAsset ? childrenColumns : undefined"
    :children-use-option="false"
    :columns
    :custom-column="false"
    :fetch-function
    :rows="10"
    :search
    :use-option="false"
    data-key="_id"
    lazy
    selection-type="checkbox"
    table-name="borrow-confirm-table"
  />
  <TSDataTable
    :key="tableKey + 1"
    v-else
    :children-columns="isLinkedAsset ? childrenColumns : undefined"
    :children-use-option="false"
    :columns
    :custom-column="false"
    :fetch-function
    :rows="10"
    :search
    :use-option="false"
    data-key="_id"
    lazy
    selection-type="single"
    table-name="borrow-confirm-table"
  />
</template>
